import { render, staticRenderFns } from "./ToolbarSubtitle.vue?vue&type=template&id=daa00e00&"
import script from "./ToolbarSubtitle.vue?vue&type=script&lang=js&"
export * from "./ToolbarSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarSubtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports